import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { submitPaymentInfoStep } from '@/modules/onboarding/actions/submitPaymentInfoStep';
import { TFsmEvent } from '@/modules/onboarding/fsm-types';
import { failedStepResult, isStepAccepted } from '@/modules/onboarding/model/stepErrors';
import { PaymentsForm } from '@/pages/ProfileEditPayments/form';
import { IFormProps } from '@/pages/Wizard/view-types';
import { AppDispatch } from '@/root-store';
import { eventTracking } from '@/services/event-tracking';

type IProps = IFormProps<TFsmEvent>;

const StepPayments: React.FC<IProps> = ({ onSwitchScreen }) => {
  const dispatch = useDispatch() as AppDispatch;

  const postForm = useCallback(
    async (formValues: Parameters<typeof submitPaymentInfoStep>[0]) => {
      const resultAction = await dispatch(submitPaymentInfoStep(formValues));

      if (submitPaymentInfoStep.fulfilled.match(resultAction)) {
        const { isSucceed, result = {} } = resultAction.payload;

        if (isSucceed && isStepAccepted(result)) {
          eventTracking.trackSnowplow({
            event: 'Onboarding - Payment - Success',
          });

          onSwitchScreen('NEXT');
        }

        return result;
      }

      return failedStepResult(resultAction.error);
    },
    [dispatch, onSwitchScreen],
  );

  return <PaymentsForm onSubmit={postForm} />;
};

export { StepPayments };
